var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:!_vm.$vuetify.breakpoint.xsOnly ? 'px-5 py-5' : ''},[_c('WatchListComponent',{attrs:{"user_id":_vm.helper.getUserId()}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }